import React from 'react';

const EmptyListIcon = () => (
  <svg width="173" height="100" viewBox="0 0 173 100" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_529_23513)">
      <rect x="24.502" y="0.369904" width="123.996" height="51.7958" rx="8.43645" fill="#EAEAEA" />
      <g filter="url(#filter0_d_529_23513)">
        <path
          d="M37.4129 24.3873C37.6729 22.868 38.9899 21.7572 40.5313 21.7572H70.5184C72.0598 21.7572 73.3768 22.868 73.6368 24.3873L74.9632 32.1387C75.282 34.0014 73.9072 35.7263 72.0204 35.8311L55.5248 36.7475L39.0293 35.8311C37.1424 35.7263 35.7677 34.0014 36.0865 32.1387L37.4129 24.3873Z"
          fill="white"
        />
        <rect width="5.04624" height="2.52312" rx="1.26156" transform="matrix(-1 0 0 1 74.4487 17.9728)" fill="white" />
        <rect width="5.04624" height="2.52312" rx="1.26156" transform="matrix(-1 0 0 1 41.6473 17.9728)" fill="white" />
        <path
          d="M42.9086 38.8919C41.8063 38.8919 40.9127 37.9983 40.9127 36.896L40.9127 33.6386L44.9044 33.6386L44.9044 36.896C44.9044 37.9983 44.0108 38.8919 42.9086 38.8919Z"
          fill="white"
          stroke="white"
          strokeWidth="1.05456"
        />
        <path
          d="M68.1386 38.8919C67.0363 38.8919 66.1428 37.9983 66.1428 36.896L66.1428 33.6386L70.1344 33.6386L70.1344 36.896C70.1344 37.9983 69.2409 38.8919 68.1386 38.8919Z"
          fill="white"
          stroke="white"
          strokeWidth="1.05456"
        />
        <path
          d="M42.4362 15.524C42.7098 14.0197 44.0199 12.9263 45.5489 12.9263H65.4995C67.0284 12.9263 68.3386 14.0197 68.6121 15.524L69.9848 23.0738C70.3379 25.0158 68.846 26.8034 66.8722 26.8034H44.1762C42.2024 26.8034 40.7105 25.0158 41.0635 23.0738L42.4362 15.524Z"
          fill="white"
        />
        <path
          d="M45.4462 16.4234C45.5534 15.9409 45.9814 15.5976 46.4756 15.5976H64.573C65.0672 15.5976 65.4952 15.9409 65.6024 16.4234L66.3966 19.9973C66.5342 20.6165 66.0981 21.2161 65.4666 21.2759L61.8897 21.6148C57.6556 22.0159 53.393 22.0159 49.1589 21.6148L45.582 21.2759C44.9505 21.2161 44.5144 20.6165 44.652 19.9973L45.4462 16.4234Z"
          fill="#EAEAEA"
        />
        <path
          d="M40.4909 27.268C40.8516 25.922 43.3103 25.4113 44.6563 25.772C46.0023 26.1326 47.8556 27.5162 47.495 28.8622C47.1343 30.2082 44.6962 31.0069 43.3502 30.6463C42.0042 30.2856 40.1302 28.614 40.4909 27.268Z"
          fill="#EAEAEA"
        />
        <path
          d="M71.0903 27.268C70.7296 25.922 68.2709 25.4113 66.9249 25.772C65.5789 26.1326 63.7255 27.5162 64.0862 28.8622C64.4469 30.2082 66.8849 31.0069 68.2309 30.6463C69.5769 30.2856 71.4509 28.614 71.0903 27.268Z"
          fill="#EAEAEA"
        />
      </g>
      <rect
        x="81.9317"
        y="12.6962"
        width="26.1044"
        height="6.52611"
        rx="3.26306"
        fill="url(#paint0_linear_529_23513)"
      />
      <rect
        x="82.5767"
        y="22.3439"
        width="56.5046"
        height="6.27829"
        rx="3.13914"
        fill="url(#paint1_linear_529_23513)"
      />
      <rect
        x="82.5767"
        y="31.7612"
        width="56.5046"
        height="6.27829"
        rx="3.13914"
        fill="url(#paint2_linear_529_23513)"
      />
    </g>
    <g filter="url(#filter1_d_529_23513)">
      <g clipPath="url(#clip1_529_23513)">
        <rect x="7.5" y="27.5383" width="158" height="66" rx="10.75" fill="#EAEAEA" />
        <g filter="url(#filter2_d_529_23513)">
          <path
            d="M23.9524 58.1422C24.2837 56.2063 25.9619 54.7909 27.9259 54.7909H66.1366C68.1006 54.7909 69.7788 56.2063 70.1101 58.1422L71.8003 68.0193C72.2064 70.3929 70.4547 72.5908 68.0504 72.7243L47.0312 73.8921L26.0121 72.7243C23.6078 72.5908 21.8561 70.3929 22.2622 68.0193L23.9524 58.1422Z"
            fill="white"
          />
          <rect
            width="6.43009"
            height="3.21505"
            rx="1.60752"
            transform="matrix(-1 0 0 1 71.1453 49.9687)"
            fill="white"
          />
          <rect
            width="6.43009"
            height="3.21505"
            rx="1.60752"
            transform="matrix(-1 0 0 1 29.3473 49.9687)"
            fill="white"
          />
          <path
            d="M30.9561 76.6245C29.5516 76.6245 28.413 75.4859 28.413 74.0814L28.413 69.9307L33.4993 69.9307L33.4993 74.0814C33.4993 75.4859 32.3607 76.6245 30.9561 76.6245Z"
            fill="white"
            stroke="white"
            strokeWidth="1.34375"
          />
          <path
            d="M63.1064 76.6245C61.7018 76.6245 60.5632 75.4859 60.5632 74.0814L60.5632 69.9307L65.6496 69.9307L65.6496 74.0814C65.6496 75.4859 64.511 76.6245 63.1064 76.6245Z"
            fill="white"
            stroke="white"
            strokeWidth="1.34375"
          />
          <path
            d="M30.3543 46.8484C30.7028 44.9316 32.3723 43.5383 34.3205 43.5383H59.7422C61.6905 43.5383 63.3599 44.9316 63.7084 46.8484L65.4576 56.4687C65.9075 58.9432 64.0065 61.2211 61.4913 61.2211H32.5714C30.0563 61.2211 28.1552 58.9432 28.6052 56.4687L30.3543 46.8484Z"
            fill="white"
          />
          <path
            d="M34.1906 47.9945C34.3272 47.3797 34.8725 46.9423 35.5023 46.9423H58.5625C59.1923 46.9423 59.7376 47.3797 59.8743 47.9945L60.8863 52.5486C61.0616 53.3375 60.5059 54.1016 59.7013 54.1778L55.1435 54.6096C49.7482 55.1208 44.3167 55.1208 38.9214 54.6096L34.3636 54.1778C33.559 54.1016 33.0032 53.3375 33.1785 52.5486L34.1906 47.9945Z"
            fill="#EAEAEA"
          />
          <path
            d="M27.8744 61.8128C28.334 60.0977 31.467 59.4469 33.1821 59.9065C34.8972 60.3661 37.2588 62.129 36.7992 63.8441C36.3396 65.5592 33.233 66.5771 31.5178 66.1175C29.8027 65.6579 27.4148 63.5279 27.8744 61.8128Z"
            fill="#EAEAEA"
          />
          <path
            d="M66.8652 61.8128C66.4057 60.0977 63.2727 59.4469 61.5576 59.9065C59.8424 60.3661 57.4809 62.129 57.9404 63.8441C58.4 65.5592 61.5067 66.5771 63.2218 66.1175C64.9369 65.6579 67.3248 63.5279 66.8652 61.8128Z"
            fill="#EAEAEA"
          />
        </g>
        <rect x="81.5" y="43.5383" width="37" height="8" rx="4" fill="url(#paint3_linear_529_23513)" />
        <rect x="81.5" y="55.5383" width="72" height="8" rx="4" fill="url(#paint4_linear_529_23513)" />
        <rect x="81.5" y="67.5383" width="72" height="8" rx="4" fill="url(#paint5_linear_529_23513)" />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_d_529_23513"
        x="22.7933"
        y="-0.320912"
        width="65.4631"
        height="52.9873"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="6.62359" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.835294 0 0 0 0 0.835294 0 0 0 0 0.835294 0 0 0 1 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_529_23513" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_529_23513" result="shape" />
      </filter>
      <filter
        id="filter1_d_529_23513"
        x="0.5"
        y="19.5383"
        width="172"
        height="80"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-1" />
        <feGaussianBlur stdDeviation="3.5" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.447059 0 0 0 0 0.447059 0 0 0 0 0.447059 0 0 0 0.08 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_529_23513" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_529_23513" result="shape" />
      </filter>
      <filter
        id="filter2_d_529_23513"
        x="5.32355"
        y="26.6583"
        width="83.4154"
        height="67.5181"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="8.44" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.835294 0 0 0 0 0.835294 0 0 0 0 0.835294 0 0 0 1 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_529_23513" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_529_23513" result="shape" />
      </filter>
      <linearGradient
        id="paint0_linear_529_23513"
        x1="81.9317"
        y1="12.6962"
        x2="104.944"
        y2="25.0038"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="1" stop-color="#F8F8F8" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_529_23513"
        x1="82.5767"
        y1="22.3439"
        x2="108.744"
        y2="53.8326"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="1" stop-color="#F8F8F8" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_529_23513"
        x1="82.5767"
        y1="31.7612"
        x2="108.744"
        y2="63.2499"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="#F8F8F8" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_529_23513"
        x1="81.5"
        y1="43.5383"
        x2="111.843"
        y2="62.3026"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="1" stopColor="#F8F8F8" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_529_23513"
        x1="81.5"
        y1="55.5383"
        x2="114.843"
        y2="95.6623"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="#F8F8F8" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_529_23513"
        x1="81.5"
        y1="67.5383"
        x2="114.843"
        y2="107.662"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stop-color="#F8F8F8" />
      </linearGradient>
      <clipPath id="clip0_529_23513">
        <rect x="24.502" y="0.369873" width="123.996" height="51.7958" rx="8" fill="white" />
      </clipPath>
      <clipPath id="clip1_529_23513">
        <rect x="7.5" y="27.5383" width="158" height="66" rx="8" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default EmptyListIcon;
